if (!customElements.get('localization-form')) {
	customElements.define(
    'localization-form',
		class LocalizationForm extends HTMLElement {
			constructor() {
				super();
				const select = this.querySelector("[data-localization-select]");
				select.addEventListener("change", e => {
					const value = e.target.value;
                    console.log(select);
					const form = select.closest(".localization-form");
                    
					const input = form.querySelector("input[data-localization-input]");
					input && input.setAttribute("value", value),
					input && form.submit()
				})
			}
		}
	);
}